module.exports = __webpack_public_path__ + "img/painpointHand.ca1258d7.svg";